import React from 'react';
import langConf from "../js/lang";

const Success = ({language}) => {
    return (
        <div className="col-xl-12 col-12">
            <p>{langConf[language].success}</p>
        </div>
    );
};

export default Success;